export default "__VITE_ASSET__NP_cFFt4__"